import { DashboardProvider } from './context/dashboard-context';
import { DashboardComponent } from './dashboard-component';
import { BaseLayoutFactory } from '../../../components/base-layout-factory';

export function DashboardFactory() {
    return (
        <BaseLayoutFactory>
            <DashboardProvider>
                <DashboardComponent />
            </DashboardProvider>
        </BaseLayoutFactory>
    );
}
